









































import { Vue, Component, Watch } from "vue-property-decorator";
import{ CustomerSchema } from "@/models/customer_schema";
import { CustomerStatus, CustomerType } from "@/models/customer";
import { EventBus } from "@/events/index";
import { StoreModule } from "@/store/types";
import { CustomerGetters } from "@/store/modules/customer/types";
import { namespace } from "vuex-class";
import moment from "moment";
import { GlobalGetters } from "@/store/modules/global/types";
import { Layers } from "@/models/map/layers";

@Component
export default class Footer extends Vue {
  protected customerData = [] as CustomerSchema[];
  @(namespace(StoreModule.Customer).Getter(CustomerGetters.GetAllCustomers))
  customers;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetActiveView))
  storeActiveView;
  // created() {
  //   if (this.$route.query && this.$route.query.region) {
  //     this.filteredCustomers = this.customers.filter((customer) => {
  //       return customer.sales_region === this.$route.query.region;
  //     });
  //   } else {
  //     this.filteredCustomers = this.customers;
  //   }
  // }

  created() {
    EventBus.$on("sendFooterData", (customers: CustomerSchema[]) => {
      this.customerData = customers;
    });
  }

    beforeDestroy() {
    EventBus.$off('sendFooterData');
  }


get filteredCustomers(): CustomerSchema[] {
  let array: CustomerSchema[] = [];
      switch (this.storeActiveView) {
      case Layers.Customers:
            array = this.customers.filter(c => c.customer_type === CustomerType.Customer || c.customer_type === CustomerType.Designer);
      break;
      case Layers.Contract:
            array = this.customers.filter(c => c.customer_type === CustomerType.Contract);
      break;
      case Layers.Beach:
            array = this.customers.filter(c => c.customer_type === CustomerType.BeachConcession);
      break;
    }
   return this.customerData.length > 0 ? this.customerData : array;
}

  get current(): number {
    let current = 0;
    this.filteredCustomers.forEach((customer) => {
      if (customer.status === CustomerStatus.Current) {
        current++;
      }
    });
    return current;
  }

  get newCustomers(): number {
    let newCount = 0;
    this.filteredCustomers.forEach((customer) => {
      if (customer.customer_since && customer.status === CustomerStatus.Current &&
          (moment().diff(moment(customer.customer_since), "years", true) <= 1)
        ) {
          newCount++;
      } // a customer is "new"  if it is marked current & was a customer since less than or equal to a year from this date
    });
    return newCount;
  }

  get priorityA(): number {
    let repTargets = 0;
    this.filteredCustomers.forEach((customer) => {
      if (customer.status === CustomerStatus.PriorityA) {
        repTargets++;
      }
    });
    return repTargets;
  }

    get priorityB(): number {
    let repTargets = 0;
    this.filteredCustomers.forEach((customer) => {
      if (customer.status === CustomerStatus.PriorityB) {
        repTargets++;
      }
    });
    return repTargets;
  }

  get frankfordTargets(): number {
    let frankfordTargets = 0;
    this.filteredCustomers.forEach((customer) => {
      if (customer.status === CustomerStatus.FrankfordTarget) {
        frankfordTargets++;
      }
    });
    return frankfordTargets;
  }

  get lost(): number {
    let lost = 0;
    this.filteredCustomers.forEach((customer) => {
      if (customer.status === CustomerStatus.Lost) {
        lost++;
      }
    });
    return lost;
  }
}
